import React from "react";
import CssClasses from "./CategoryPicker.css";
import { connect } from "react-redux";
import * as StoreActions from "../../../ReduxStore/Actions/ActionIndex";
import CategoryButton from "../../UI/CategoryButton/CategoryButton";
import LeagueButton from "../../UI/LeagueButton/LeagueButton";
import * as PickerIDs from "../../../HOCs/Constants/PickerID";
import * as MostPlayedOptionIDs from "../../../HOCs/Constants/MostPlayedOptionID";

import Auxx from "../../../HOCs/AUXX/Auxx";
import SiteIcons from "../../../assets/fonts/site_icons/style.css";

import beepHigh from "../../../assets/sounds/beep_high.mp3";

let _props = null;

const CategoryPicker = props => {
  _props = props;

  if (props.activeMostPlayedButtonID !== MostPlayedOptionIDs.PREMATCH) {
    //ako je u bilo kojem od ovih biralica van kalendara, nista, gasi
    return null;
  }

  if (!props.prematchCategories) {
    //javi da odabere nesto
    return (
      <div className={CssClasses.container}>
        <audio
          ref={sound => {
            this.beepHigh = sound;
          }}
        >
          <source src={beepHigh} type="audio/mpeg" />
        </audio>
        <div className={CssClasses.instructions}>
          <div>
            <span
              className={[SiteIcons.site_icon_info, CssClasses.infoIcon].join(
                " "
              )}
            />
          </div>
          Odaberite sport iz gornjeg izbornika za prikaz kategorija...
        </div>
      </div>
    );
  }

  //pripremi brojalicu za kad ide
  let tournamentsToRender = [];
  let drawnCounter = 0;
  let shouldDraw = false; //indikator za parno

  if (
    props.prematchCategories.find(x => x.IDCategory === props.activeCategoryID)
  ) {
    tournamentsToRender = props.prematchCategories.find(
      x => x.IDCategory === props.activeCategoryID
    ).Tournaments;
  }

  return (
    <div className="outerContainer">
      <div className={CssClasses.container}>
        <audio
          ref={sound => {
            this.beepHigh = sound;
          }}
        >
          <source src={beepHigh} type="audio/mpeg" />
        </audio>
        {props.prematchCategories.map(category => {
          drawnCounter++;

          if (props.activeCategoryID === category.IDCategory) {
            shouldDraw = true;
          }
          return (
            <Auxx key={category.IDCategory}>
              <CategoryButton
                icon={category.IconCode}
                onButtonClicked={specialOptionButtonClick}
                title={category.TitleCategory}
                id={category.IDCategory}
                isActive={category.IDCategory === props.activeCategoryID}
                eventCount={category.EventCount}
                countryCode={""}
              />

              {shouldDraw &&
              (drawnCounter % 2 === 0 ||
                drawnCounter === props.prematchCategories.length) && //ako je parni ili si dosao do kraja, crtaj
              tournamentsToRender ? (
                <div className={CssClasses.leagueButtons}>
                  {tournamentsToRender.map(t => {
                    shouldDraw = false; //nacrtao

                    return (
                      <LeagueButton
                        onButtonClicked={leagueButtonClick}
                        titleCategory={t.TitleTournament}
                        titleTournament={""}
                        id={t.IDTournament}
                        isActive={t.IDTournament === props.activeLeagueID}
                        eventCount={t.EventCount}
                        sportID={t.IDSport}
                        key={t.IDTournament}
                        adjustTopMarginFlag
                      />
                    );
                  })}
                </div>
              ) : null}
            </Auxx>
          );
        })}
      </div>
    </div>
  );
};

const specialOptionButtonClick = id => {
  console.log("Button click.." + id);
  //_props.onChangeLastUsedPicker(PickerIDs.COUNTRIES_AND_CATEGORIES);

  if (this.beepHigh) {
    this.beepHigh.play();
  }

  //resetiraj ligu
  _props.onChangeCurrentLeague(-1);
  //i biraj cat
  _props.onChangeCurrentCategory(id);

  //gasi akcije terminala
  _props.setTerminalActionsActiveButton(0);
};

const leagueButtonClick = id => {
  console.log("Button click.." + id);

  if (this.beepHigh) {
    this.beepHigh.play();
  }

  _props.onChangeCurrentLeague(id);

  //gasi akcije terminala
  _props.setTerminalActionsActiveButton(0);
};

const mapStateToProps = state => {
  return {
    activeCategoryID: state.rrNavigation.categoryID,
    activeLeagueID: state.rrNavigation.leagueID,
    prematchCategories: state.rrSportEvent.prematchCategories,
    updateTimestamp: state.rrSportEvent.updateTimestamp,
    activeMostPlayedButtonID: state.rrNavigation.mostPlayedButtonID
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onChangeCurrentCategory: categoryID =>
      dispatch(StoreActions.ChangeCategoryItem(categoryID)),
    onChangeLastUsedPicker: pickerID =>
      dispatch(StoreActions.ChangeLastUsedPicker(pickerID)),
    onChangeCurrentLeague: leagueID =>
      dispatch(StoreActions.ChangeLeagueItem(leagueID)),
    setTerminalActionsActiveButton: buttonID =>
      dispatch(StoreActions.SetTerminalActionsActiveButton(buttonID))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CategoryPicker);



// WEBPACK FOOTER //
// ./src/Components/Navigation/CategoryPicker/CategoryPicker.js